const bodyPartDropdown = {
  id: 'body-part',
  label: 'Body Part',
  canSelectMultiple: true,
  options: [
    { value: 'Abs', label: 'Abs' },
    { value: 'Arms', label: 'Arms' },
    { value: 'Back', label: 'Back' },
    { value: 'Chest', label: 'Chest' },
    { value: 'Glutes', label: 'Glutes' },
    { value: 'Lower Legs', label: 'Lower Legs' },
    { value: 'Shoulders', label: 'Shoulders' },
    { value: 'Upper Legs', label: 'Upper Legs' },
  ],
};

const difficultyDropdown = {
  id: 'difficulty',
  label: 'Difficulty',
  canSelectMultiple: true,
  options: [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' },
  ],
};

const equipmentDropdown = {
  id: 'equipment',
  label: 'Equipment',
  canSelectMultiple: true,
  options: [
    { label: 'No equipment', value: 'No equipment' },
    { label: 'At-home equipment', value: 'At-home equipment' },
    { label: 'Gym-based equipment', value: 'Gym-based equipment' },
  ],
};

export const exerciseDropdowns = [bodyPartDropdown, difficultyDropdown, equipmentDropdown];
